import "./SectorExpertise.module.css";
import Header from "@/reusable_sections/Header";
import Industries from "./sections/Industries";
import Results from "./sections/Results";
import Benefits from "./sections/Benefits";
import Footer from "@/reusable_sections/Footer";
export default function SectorExpertisePage() {
  return <div>
      <Header />
      <Industries />
      <Results />
      <Benefits />
      <Footer />
    </div>;
}